var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19756 20.6369C9.46101 24.9004 16.3734 24.9003 20.6369 20.6368C24.9003 16.3734 24.9003 9.46103 20.6369 5.19759C16.3734 0.934138 9.46106 0.934138 5.19761 5.19759C0.934164 9.46104 0.934114 16.3735 5.19756 20.6369Z",
    stroke: "#606F8D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6374 20.6367L33.0004 33",
    stroke: "#606F8D",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4834 25.4832L32.3079 32.3075",
    stroke: "#606F8D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchNew);
export default __webpack_public_path__ + "static/media/icon_search_new.da9ee84eb636c831642bda1c1fb6fe77.svg";
export { ForwardRef as ReactComponent };